/// <amd-module name="Test/AssociateToTestCase/Actions/AssociateToTestCaseActionCreator" />
import * as TCMContracts from "Test/common-util/Contracts/Test";
import { ITestCaseResultHolder, AssociateToTestCaseActionHub } from "Test/AssociateToTestCase/Actions/AssociateToTestCaseActionHub";
import { AssociateToTestCaseSource } from "Test/AssociateToTestCase/Source/AssociateToTestCaseSource";
import { IVssPageContext } from "VSS/Platform/Context";
import { WorkItem } from "Wit/Clients/Wit/Contracts/WorkItemTracking";

export class AssociateToTestCaseActionCreator {
    private _source: AssociateToTestCaseSource;
    constructor(private _pageContext: IVssPageContext, private _AssociateToTestCaseActionHub: AssociateToTestCaseActionHub) {
        this._source = AssociateToTestCaseSource.getInstance();
    }

    public initialize(testRunId: number, testResultId: number): Promise<void> {
        const resultDetailsPromise = this._source.getSelectedTestCaseResult(this._pageContext, testRunId, testResultId);

        return Promise.all([resultDetailsPromise]).then(
            responses => {
                const result: TCMContracts.TestCaseResult = responses[0];
                console.log("Successfully fetched the SelectedTestResult Details");

                const testCaseResultHolder: ITestCaseResultHolder = {
                    testCaseResult: result,
                    workItems: [],
                    fullyQualifiedName: ""
                };

                //Updated the AutomatedTestName based on the AutomatedTestType for Unique Associations
                testCaseResultHolder.fullyQualifiedName = this._updateAutomatedTestNameBasedOnType(result);

                const workItemsPromise = this._source.queryByWiqlAsync(this._pageContext, testCaseResultHolder.fullyQualifiedName);
        
                workItemsPromise.then((wiResult) => {
                    console.log("Successfully fetched WIs Associated with the SelectedTest");
                    testCaseResultHolder.workItems = wiResult;
                    this._AssociateToTestCaseActionHub.associateToTestCaseDialog.invoke(testCaseResultHolder);
                },
                error => {
                    this._AssociateToTestCaseActionHub.onError.invoke(error.toString());
                });

                if(testCaseResultHolder.workItems.length == 0) {
                    console.log("No existing associations are fetched");
                    this._AssociateToTestCaseActionHub.associateToTestCaseDialog.invoke(testCaseResultHolder);
                }
            },
            error => {
                this._AssociateToTestCaseActionHub.onError.invoke(error.toString());
            }
        );
    }

    public async associateToTestCase(testCaseId: string, automatedTestName: string, automatedTestStorage: string): Promise<void> {
        let testId: string;
        await this._source.getHashedValue(automatedTestName, this._pageContext).then((response) => {
            testId = response;
            this._source.addAssociationToWorkItemAsync(testCaseId, testId, automatedTestName, automatedTestStorage, this._pageContext);
        },
        error => {
            this._AssociateToTestCaseActionHub.onError.invoke(error.toString());
            console.log("Associate To TestCase Failed");
        })
    }

    public async addAssociateTestCase(testCaseId: string): Promise<void> {
        let data: WorkItem;
        await this._source.getWorkItemById(this._pageContext, parseInt(testCaseId)).then((response) => {
            data = response;
            this._AssociateToTestCaseActionHub.addAssociateTestCase.invoke(data);
        },
        error => {
            this._AssociateToTestCaseActionHub.addAssociateTestCaseFailure.invoke("Failed to get TestCaseId");
        });
    }

    // This method will udpate the automatedTestName based on the Type viz., Vstest, JUnit, Xunit, NUnit, etc
    private _updateAutomatedTestNameBasedOnType(testResult: TCMContracts.TestCaseResult): string {
        let updatedAutomatedTestName: string = testResult.automatedTestName;

        if(testResult.automatedTestType === "JUnit") {
            updatedAutomatedTestName = testResult.automatedTestStorage + "." + testResult.automatedTestName;
        }

        // For Types other than JUnit like NUnit, XUnit, Vstest(Types), the automatedTestName is already a fullyQualifiedName which is unique for a testcase
        console.log("Updated AutomatedTestName: " + updatedAutomatedTestName);
        return updatedAutomatedTestName;
    }
}